<template>
  <section class="grid-flex column">
    <div class="box w100">
      <div class="box-title flex middle">
        <div class="flex-1">
          Regras Automáticas de atribuição
          <div class="margin-top-s">
            <small>A cada 10 minutos as regras são executadas e todas campanhas que entrarem em alguma regra vão ser associadas ao produto automáticamente.</small>
          </div>
        </div>
        <div class="flex-1">
          <div class="flex end">
            <div @click="openModalRule()" class="button primary">
              Criar Regra
            </div>
          </div>
        </div>
      </div>
      <div class="box-content">
        <div class="">
          <ul class="list-campaigns">
            <li v-for="(rule, index) in rules" :key="index">
              <div class="flex row middle">
                <div class="flex-3">
                  <i
                    v-if="rule.platform === 'fbads'"
                    class="fa fa-facebook-square fbads"
                  ></i>
                  <i
                    v-if="rule.platform === 'gads'"
                    class="fab fa-google"
                  ></i>
                  Campanha Contém o termo: <b>{{ rule.term }}</b>
                </div>
                <div class="flex-1">
                  <div class="flex end">
                    <div @click="openModalRule(rule)" class="button secondary" >EDITAR</div>
                    <div @click="openModalRemove(rule)" class="button secondary" style="margin-left: 8px">REMOVER</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div v-if="isEmptyRule" class="flex center">
          <p>
            Não existe nenhuma regra.
          </p>
        </div>
        <div v-if="loaderRules">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>


    <div class="box w100 margin-top-l" style="margin-left: 0px;">
      <div class="box-title">
        <div class="flex middle">
          <div class="flex-1">
            <m-switch
              label="Ativar todas campanhas"
              tooltip="Somente as campanhas visíveis serão ativadas. Combine a busca com a ativação em massa."
              v-model="activeAll"
            ></m-switch>
          </div>
          <div class="flex-1">
            <div class="flex end">
              <input
                class="input"
                type="text"
                v-model="search"
                placeholder="Buscar campanhas"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="box-content">
        <ul class="list-campaigns">
          <li v-for="(cam, index) in renderCampaigns" :key="index">
            <div class="flex row">
              <div class="flex-3">
                <i
                  v-if="cam.platform === 'FBADS'"
                  class="fa fa-facebook-square fbads"
                ></i>
                <i
                  v-if="cam.platform === 'GADS'"
                  class="fab fa-google"
                ></i>
                {{ cam.name | protect}}
              </div>
              <div class="flex-1">
                <div class="flex end">
                  <m-switch
                    v-model="cam.active"
                    @change="updateProductCampaign(cam)"
                  ></m-switch>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <span v-if="isEmpty" class="center-txt margin-top-l">
          <p>Não encontramos campanhas para exibir!</p>
        </span>
        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>

    <modal :title="`${isEditRule ? 'Editar Regra' : 'Criar Regra' }`" :show="showCreateModalRules" @close="closeModalRule()">
      <div class="content" slot="content">
        <validation-observer ref="form">
        <form>
          <div class="margin-top-l">
            <validation-provider
              name="termo"
              rules="required"
              v-slot="{ errors }"
            >
              <div
                class="form-field item group-input "
                :class="{ errors: errors[0] }"
              >
                <div class="flex column">
                  <label>
                    Termo:
                  </label>
                  <small>O termo deve estar contido no nome das campahas</small>
                </div>
                <input
                  type="text"
                  v-model="newCampaignRule.term"
                  placeholder="Exmplo: [PRODUTO1]"
                />
                <span class="erros-alert">{{ errors[0] }}</span>
              </div>
              <div class="form-field item group-input">
                <label>Plataforma:</label>
                <select class="input" v-model="newCampaignRule.platform">
                  <option value="">Seleciona</option>
                  <option v-for="(f, index) in listPlatformRules" :key="index" :value="f.value" :selected="f.value === newCampaignRule.platform">
                    {{ f.label }}
                  </option>
                </select>
              </div>
            </validation-provider>
          </div>
        </form>
      </validation-observer>
      </div>
      <div class="action margin-top-l" slot="action">
        <div class="flex center">
          <button @click="closeModalRule()" class="button secondary">
            Voltar
          </button>
          <button
            type="submit"
            @click="createOrUpdateCampaignRule()"
            class="button primary"
            style="margin-left: 8px"
          >
            {{ isEditRule ? "Editar" : "Criar" }}
          </button>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModalRules"
      description="Você tem certeza que deseja deletar essa regra?"
      @cancel="
        showDeleteModalRules = false;
        selecteRule = null;
      "
      @accept="deleteCampaignRule(selecteRule)"
    ></modal-confirm>
  </section>
</template>

<script>
import MSwitch from "@/components/MSwitch.vue";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import {
  getCampaignsFacebook,
  getCampaignsGoogle
} from "@/services/campaigns";

import {
  getAllCampaignsProduct,
  updateProductCampaign,
  updateProductCampaignMassive,
} from "@/services/product";


import {
    getCampaignsRules,
    createCampaignRule,
    updateCampaignRule,
    deleteCampaignRule,
} from "@/services/productCampaignRule";
  

const emptyCampaignRule = {
  term: '',
  platform: 'fbads',
}
export default {
  name: "campaign-product",
  components: {
    MSwitch,
    Modal,
    ModalConfirm,
  },
  props: ["product_id"],
  data() {
    return {
      activeAll: false,
      campaigns: [],
      campaignsProduct: [],
      newCampaignRule: Object.assign({}, emptyCampaignRule),
      rules: [],
      listPlatformRules: [
        { value: 'fbads', label: 'FACEBOOK ADS'},
        { value: 'gads', label: 'GOOGLE ADS'},
      ],
      loaderRules: false,
      showDeleteModalRules: false,
      showCreateModalRules: false,
      selecteRule: null,
      search: "",
      searchRender: "",
      flagChangeAll: false,
      loading: false,
    };
  },
  mounted() {
    this.getAllCampaignsProduct();
    this.getAllCampaigns();
    this.getCampaignsRules();
  },
  computed: {
    isEditRule() {
      return this.newCampaignRule.id ? true : false
    },
    renderCampaigns() {
      let _setStatus = (campaigns, campaigns_product) => {
        if (!campaigns || !campaigns_product) {
          return;
        }

        let getIdsProductCampaign = campaigns_product.map((p) => p.campaign_id);

        campaigns.forEach((c) => {
          if (getIdsProductCampaign.includes(c.id)) {
            c.active = true;
          }
        });
      };

      let _sortCampaigns = (auxCampaigns) => {
        auxCampaigns.sort(function(a, b) {
          return !a.active && b.active;
        });
      };

      let auxCampaigns = this.campaigns;
      if (!this.searchRender) {
        _setStatus(auxCampaigns, this.campaignsProduct);
        _sortCampaigns(auxCampaigns);
        return auxCampaigns;
      }

      auxCampaigns = this.campaigns.filter((e) => {
        let auxName = e.name.toLowerCase();
        return auxName.includes(this.searchRender.toLowerCase());
      });

      _setStatus(auxCampaigns, this.campaignsProduct);

      _sortCampaigns(auxCampaigns);

      return auxCampaigns;
    },
    isEmpty() {
      return (
        !this.loading &&
        this.renderCampaigns &&
        this.renderCampaigns.length === 0
      );
    },
    isEmptyRule() {
      return (
        !this.loaderRules &&
        this.rules &&
        this.rules.length === 0
      );
    },
  },
  watch: {
    search() {
      setTimeout(() => (this.searchRender = this.search), 1000);
    },
    activeAll(value) {
      this.flagChangeAll = true;
      this.renderCampaigns.forEach((e) => {
        if (!e.active) {
          e.active = value;
        }

        if (e.active && !value) {
          e.active = value;
        }
      });

      this.updateProductCampaignsAll();
    },
  },
  methods: {
    createOrUpdateCampaignRule() {
      if (this.newCampaignRule.id) {
        this.updateCampaignRule()
      } else {
        this.createCampaignRule()
      }
      this.showCreateModalRules = false
    },
    closeModalRule() {
      this.showCreateModalRules = false
      this.newCampaignRule = Object.assign({}, emptyCampaignRule)
    },
    openModalRule(rule) {
      this.showCreateModalRules = true
      if (rule) {
        this.newCampaignRule = rule
        return
      }

      this.newCampaignRule = Object.assign({}, emptyCampaignRule)
    },
    openModalRemove(rule) {
      this.showDeleteModalRules = true
      this.selecteRule = rule
    },
    getAllCampaigns() {
      this.loading = true
      Promise.all([
        getCampaignsFacebook()
          .then((result) => {
            this.campaigns = this.campaigns.concat(result.campaigns.map((c) => {
              return { ...c, platform: "FBADS" };
            }));
          }),
        getCampaignsGoogle()
        .then((result) => {
          this.campaigns = this.campaigns.concat(result.campaigns.map((c) => {
            return { ...c, platform: "GADS" };
          }));
        })
      ])
      .catch((error) => {
        if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
          title: "Erro",
            message: "Falhou ao buscar campanhas",
          });
      })
      .finally(() => {
        this.loading = false;
      })
    },
    updateProductCampaign(campaign) {
      if (this.flagChangeAll) {
        return;
      }

      let params = {
        campaign_id: campaign.id,
        platform: campaign.platform,
        active: campaign.active,
      };

      updateProductCampaign(this.product_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Campanha atualizada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou em atualizar campanha",
          });

          campaign.active = !campaign.active;
        });
    },
    updateProductCampaignsAll() {
      let camapigns_active = this.renderCampaigns.filter((c) => c.active);
      let campaigns_id_active = camapigns_active.map((c) => c.id);
      let campaigns_product_id = this.campaignsProduct.map(
        (c) => c.campaign_id
      );

      let campaigns_to_active_id = campaigns_id_active.filter(
        (c) => !campaigns_product_id.includes(c)
      );

      let list_campaigns_to_active = []
      camapigns_active.forEach(c => {
        if (!campaigns_to_active_id.includes(c.id)) {
          return
        }

        list_campaigns_to_active.push({
          id: c.id,
          platform: c.platform,
        })
      })
      let campaigns_to_disable_id = campaigns_product_id.filter(
        (c) => !campaigns_id_active.includes(c)
      );

      let params = {
        campaigns_to_enable: list_campaigns_to_active,
        campaigns_to_disable: campaigns_to_disable_id,
      };

      updateProductCampaignMassive(this.product_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Campanhas editada com sucesso em massa",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falho ao tentar atualizar campanhas em massa",
          });
        })
        .finally(() => {
          this.flagChangeAll = false;
        });
    },
    getAllCampaignsProduct() {
      getAllCampaignsProduct(this.product_id)
        .then((result) => {
          this.campaignsProduct = result.campaigns;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falho ao tentar atualizar campanha",
          });
        });
    },
    getCampaignsRules() {
      getCampaignsRules(this.product_id)
        .then(result => {
          this.rules = result.rules
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        }) 
    },
    createCampaignRule() {
      let params = {
        term: this.newCampaignRule.term,
        platform: this.newCampaignRule.platform,
      }
      createCampaignRule(this.product_id, params)
        .then(result => {
          this.rules.push(result)
          this.$toast.success({
            title:'Sucesso',
            message:'Regra criada com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        }) 
    },
    updateCampaignRule() {
      let params = {
        term: this.newCampaignRule.term,
        platform: this.newCampaignRule.platform,
      }
      updateCampaignRule(this.product_id, this.newCampaignRule.id, params)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Regra editada com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        }) 
    },
    deleteCampaignRule(rule) {
      deleteCampaignRule(this.product_id, rule.id)
        .then(() => {
          this.rules = this.rules.filter(r => r.id != rule.id)
          this.showDeleteModalRules = false
          this.selecteRule = null

          this.$toast.success({
            title:'Sucesso',
            message:'Regra deletada com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        }) 
    }
  },
};
</script>

<style lang="scss" scoped>
.box-title {
  input {
    max-width: 340px;
  }
}

.box-content {
  height: auto;
  max-height: 500px;
  overflow-y: scroll;
}

.list-campaigns {
  li {
    list-style-type: none;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #c2c2c258;
  }
}

.fbads {
  color: #3b5998;
}
</style>
